import SiteLoader from "./SiteLoader";
import SiteTransition from "./SiteTransition";
//import SiteAsyncTransition from "./SiteAsyncTransition";

export default [
  new SiteLoader(), 
  new SiteTransition(),
  //new SiteAsyncTransition(),
];
